import { call, put, takeEvery } from 'redux-saga/effects';
import { appointmentActions, appointmentActionsTypes } from './actions';
import API from '../../API/endpoints';
import { store } from '../store';
import { userActions } from '../user/actions';

function* getAppointments(action) {
  yield put(appointmentActions.loading(true));
  try {
    const {
      userType,
      id,
      token,
      isDone,
      isPayed,
      queryParams,
      queryValues,
      isCanceled = false,
    } = action.payload;
    let urlParams = `${userType}__id=${id}&is_done=${isDone}&is_cancelled=${isCanceled}`;
    if (queryParams.length > 0) {
      for (let i = 0; i < queryParams.length; i++) {
        urlParams += `&${queryParams[i]}=${queryValues[i]}`;
      }
    }

    console.log('esta es la url en saga ', urlParams);
    const response = yield call(API.getAppointments, urlParams, token);

    yield put(appointmentActions.successGetAppointment(response.data));
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}

function* getAppointmentsLight(action) {
  yield put(appointmentActions.loading(true));
  try {
    const {
      userType,
      id,
      token,
      isDone,
      isPayed,
      queryParams,
      queryValues,
      isCanceled = false,
    } = action.payload;
    let urlParams = `${userType}__id=${id}&is_done=${isDone}&is_cancelled=${isCanceled}`;
    if (queryParams.length > 0) {
      for (let i = 0; i < queryParams.length; i++) {
        urlParams += `&${queryParams[i]}=${queryValues[i]}`;
      }
    }

    const response = yield call(API.getAppointmentsLight, urlParams, token);

    yield put(appointmentActions.successGetAppointment(response.data));
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}

function* getRapidQueues() {
  yield put(appointmentActions.loading(true));
  try {
    const response = yield call(API.getRapidQueues);

    yield put(appointmentActions.successGetRapidQueues(response.data));
  } catch (e) {
    console.error(e);
    yield put(appointmentActions.successGetRapidQueues({}));
  }
  yield put(appointmentActions.loading(false));
}

function* rapidQueuePush(action) {
  yield put(appointmentActions.loading(true));
  try {
    yield call(API.rapidQueuePush, action.payload);
    yield put(appointmentActions.rapidQueuePushSuccess());
  } catch (e) {
    throw e;
  } finally {
    yield put(appointmentActions.loading(false));
  }
}

function* rapidQueueTakePatient(action) {
  yield put(appointmentActions.loading(true));
  try {
    yield call(API.rapidQueueTakePatient, action.payload);
    yield put(appointmentActions.rapidQueueTakePatientSuccess());
  } catch (e) {
    throw e;
  } finally {
    yield put(appointmentActions.loading(false));
  }
}

function* createAppointment(action) {
  yield put(appointmentActions.loading(true));
  try {
    const {
      scheduleId,
      price,
      reason,
      doctor,
      patient,
      token,
      allergiesObjects,
      medicationsObjects,
      diseasesObjects,
      injuredArea,
      physicalExamination,
      symptoms,
      symptomsTime,
      spo2,
      glucose,
      systolicPressure,
      diastolicPressure,
      heartRate,
      temperature,
      expNum,
      respiratoryRate,
      consentFile,
    } = action.payload;
    const allergiesIds = allergiesObjects.map((allergie) => allergie.id); // este map se hace para pasar solo el array de  ids y no todos los  objectos
    const medicationsIds = medicationsObjects.map(
      (medication) => medication.id
    );
    const diseasesIds = diseasesObjects.map((disease) => disease.id);
    const body = {
      schedule: scheduleId,
      price,
      patient_appointment_reason: reason,
      doctor,
      patient,
      ...(allergiesIds.length && { allergies: allergiesIds }), // si el array de alergias esta vacio entonces no agrega la propiedad allergies al objeto
      ...(medicationsIds.length && { medications: medicationsIds }),
      ...(diseasesIds.length && { diseases: diseasesIds }),
      injured_area: injuredArea,
      physical_examination: physicalExamination,
      symptoms: symptoms,
      symptoms_time: symptomsTime,
      spo2: spo2,
      glucose: glucose,
      systolic_pressure: systolicPressure,
      diastolic_pressure: diastolicPressure,
      heart_rate: heartRate,
      temperature: temperature,
      expedient_number: expNum,
      respiratory_rate: respiratoryRate
    };
    const response = yield call(API.createAppointmentFull, body, token);

    yield put(
      appointmentActions.successCreateAppointment({
        message: 'Appointment creado con exito',
        data: response.data,
      })
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al crear consulta médica'));
  }
  yield put(appointmentActions.loading(false));
}

function* getAppointmentPDFdetails(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { appointmentId, appointmentDate, token } = action.payload;
    const response = yield call(
      API.getAppointmentPDFdetails,
      appointmentId,
      token
    );

    const fileName = `detalles_consulta_${appointmentDate}.pdf`;

    if (response.headers['content-type'] === 'application/pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      yield put(appointmentActions.error('Invalid file format'));
    }
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al descargar PDF de detalles'));
  }
  yield put(appointmentActions.loading(false));
}

function* getAppointmentConsentFile(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { appointmentId, appointmentDate, token } = action.payload;
    const response = yield call(
      API.getAppointmentConsentFile,
      appointmentId,
      token
    );

    const fileName = response.data.filename;
    const url = response.data.url;

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al descargar consentimiento'));
  }
  yield put(appointmentActions.loading(false));
}

function* getIcdCodeByAppointmentId(action) {
  const { appointmentId, token } = action.payload;
  yield put(
    appointmentActions.loadingIcdCodeByAppointmentId(appointmentId, true)
  );
  try {
    const response = yield call(
      API.getIcdCodeByAppointmentId,
      appointmentId,
      token
    );
    const data = response.data;
    const codes = Array.isArray(data) ? data : data.results || [];

    yield put(
      appointmentActions.successGetIcdCodeByAppointmentId(appointmentId, codes)
    );
  } catch (e) {
    if (e.response?.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.errorIcdCodeByAppointmentId(
        appointmentId,
        'Error al traer los códigos ICD'
      )
    );
  }
}

function* getConsultationFormat(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { appointmentId, token } = action.payload;
    const response = yield call(
      API.getConsultationFormat,
      appointmentId,
      token
    );

    const fileName = `nota_medica_${appointmentId}.pdf`;

    if (response.headers['content-type'] === 'application/pdf') {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      yield put(appointmentActions.error('Invalid file format'));
    }
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al descargar informe'));
  }
  yield put(appointmentActions.loading(false));
}

function* updateAppointment(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, token } = action.payload;
    const { isInformation } = body;
    let newBody = body;
    if (isInformation) {
      const allergiesIds = body.allergies.map((allergie) => allergie.id); // este map se hace para pasar solo el array de  ids y no todos los  objectos
      const medicationsIds = body.medications.map(
        (medication) => medication.id
      );
      const diseasesIds = body.diseases.map((disease) => disease.id);
      newBody = {
        ...body,
        ...(allergiesIds.length && { allergies: allergiesIds }), // si el array de alergias esta vacio entonces no agrega la propiedad allergies al objeto
        ...(medicationsIds.length && { medications: medicationsIds }),
        ...(diseasesIds.length && { diseases: diseasesIds }),
      };
    }
    const response = yield call(
      API.updateAppointmentFull,
      newBody,
      body.appointmentId,
      token
    );

    if (body.is_cancelled) {
      yield put(
        appointmentActions.successUpdateAppointment({
          message: 'Appointment eliminado con exito',
          data: response.data,
        })
      );
    } else {
      yield put(
        appointmentActions.successUpdateAppointment({
          message: 'Appointment actualizado con exito',
          data: response.data,
        })
      );
    }
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al crear disponibilidad'));
  }
  yield put(appointmentActions.loading(false));
}

function* deleteAppointment(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { appointmentId, token } = action.payload;

    yield call(API.deleteAppointmentFull, appointmentId, token);
    yield put(
      appointmentActions.successDeleteAppointment(
        'Appointment eliminado con exito'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al borrar cita'));
  }
  yield put(appointmentActions.loading(false));
}

function* uploadAppointmentFiles(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, token } = action.payload;

    const response = yield call(API.uploadeAppointmenFiles, body, token);

    yield put(
      appointmentActions.successUploadAppointmentFiles({
        uploadFiles: response.data,
        message: 'Appointment creado y consentimiento subido con exito',
      })
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(userActions.error('Error al subir la foto de perfil'));
  }
  yield put(appointmentActions.loading(false));
}

function* deleteAppointmentFile(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { fileId, token } = action.payload;

    yield call(API.deleteAppointmentFile, fileId, token);
    yield put(
      appointmentActions.successDeleteAppointmentFile(
        'Adjunto eliminado con exito'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al borrar archivo'));
  }
  yield put(appointmentActions.loading(false));
}

function* uploadConsentFile(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, token } = action.payload;

    const response = yield call(API.uploadConsentFile, body, token);

    yield put(
      appointmentActions.successUploadAppointmentConsentFile({
        consentFile: response.data,
        message: 'Appointment creado y consentimiento subido con exito',
      })
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(userActions.error('Error al subir archivo de consentimiento'));
  }
  yield put(appointmentActions.loading(false));
}

function* deleteAppointmentConsentFile(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { fileId, token } = action.payload;

    yield call(API.deleteAppointmentConsentFile, fileId, token);
    yield put(
      appointmentActions.successDeleteAppointmentConsentFile(
        'Archivo de consentimiento eliminado con exito'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.error('Error al borrar archivo de consentimiento')
    );
  }
  yield put(appointmentActions.loading(false));
}

function* getScheduleRequests(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { queryId, token } = action.payload;

    const response = yield call(API.getScheduleRequests, queryId, token);

    yield put(appointmentActions.successGetScheduleRequests(response.data));
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}
function* getSchedules(action) {
  //yield put(appointmentActions.loading(true));
  try {
    const { start, end, doctorId, token } = action.payload;
    const response = yield call(
      API.getSchedulesByDate,
      start,
      end,
      doctorId,
      token
    );

    yield put(appointmentActions.successGetSchedules(response.data));
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.error('Error al traer los datos de schedules')
    );
  }
  //yield put(appointmentActions.loading(false));
}

function* createScheduleRequests(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, token } = action.payload;

    yield call(API.createScheduleRequests, body, token);

    yield put(
      appointmentActions.successScheduleRequestAction(
        'Solicitud creada con éxito'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}

function* updateScheduleRequests(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { id, body, queryId, token } = action.payload;

    yield call(API.updateScheduleRequests, id, body, token);
    //const response = yield call(API.getScheduleRequests, queryId, token);

    yield put(
      appointmentActions.successUpdateScheduleRequests(
        'Schedule request actualizada'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.error('Ocurrió un problema al actualizar la solicitud')
    );
  }
  yield put(appointmentActions.loading(false));
}

function* acceptScheduleRequests(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, token } = action.payload;

    const response = yield call(API.acceptScheduleRequest, body, token);

    yield put(appointmentActions.successScheduleRequestAccept(response.data));
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}

function* createSchedule(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { body, isMultiple, token } = action.payload;

    const response = yield call(API.createSchedule, body, isMultiple, token);

    yield put(
      appointmentActions.successCreateSchedule({
        message: 'schedule creado con exito',
        data: response.data,
      })
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al crear disponibilidad'));
  }
  yield put(appointmentActions.loading(false));
}

function* deleteSchedule(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { scheduleId, token, isMultiple } = action.payload;

    yield call(API.deleteSchedule, token, scheduleId, isMultiple);
    yield put(
      appointmentActions.successDeleteSchedule('Schedule eliminado con exito')
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al borrar disponibilidad'));
  }
  yield put(appointmentActions.loading(false));
}

function* createAppointmentLight(action) {
  yield put(appointmentActions.loading(true));
  try {
    const {
      scheduleId,
      reason,
      doctor,
      patient,
      token,
      allergiesObjects,
      medicationsObjects,
      diseasesObjects,
      injuredArea,
      physicalExamination,
      symptoms,
      symptomsTime,
      spo2,
      glucose,
      systolicPressure,
      diastolicPressure,
      heartRate,
      temperature,
    } = action.payload;
    const allergiesIds = allergiesObjects.map((allergie) => allergie.id); // este map se hace para pasar solo el array de  ids y no todos los  objectos
    const medicationsIds = medicationsObjects.map(
      (medication) => medication.id
    );
    const diseasesIds = diseasesObjects.map((disease) => disease.id);
    const body = {
      schedule: scheduleId,
      patient_appointment_reason: reason,
      doctor,
      patient,
      ...(allergiesIds.length && { allergies: allergiesIds }), // si el array de alergias esta vacio entonces no agrega la propiedad allergies al objeto
      ...(medicationsIds.length && { medications: medicationsIds }),
      ...(diseasesIds.length && { diseases: diseasesIds }),
      injured_area: injuredArea,
      physical_examination: physicalExamination,
      symptoms: symptoms,
      symptoms_time: symptomsTime,
      spo2: spo2,
      glucose: glucose,
      systolic_pressure: systolicPressure,
      diastolic_pressure: diastolicPressure,
      heart_rate: heartRate,
      temperature: temperature,
    };

    const response = yield call(API.createAppointmentLight, body, token);

    yield put(
      appointmentActions.successCreateAppointment({
        message: 'Appointment creado con exito',
        data: response.data,
      })
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al crear consulta médica'));
  }
  yield put(appointmentActions.loading(false));
}

function* updateAppointmentLight(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { id, body, token } = action.payload;

    const response = yield call(API.updateAppointmentLight, id, body, token);

    yield put(
      appointmentActions.successUpdateAppointmentLight(
        'Appointment actualizado con exito'
      )
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.error('Ocurrió un problema al actualizar la solicitud')
    );
  }
  yield put(appointmentActions.loading(false));
}

function* resendCode(action) {
  yield put(appointmentActions.loading(true));
  try {
    const { id, token } = action.payload;

    const response = yield call(API.resendCode, id, token);

    yield put(
      appointmentActions.successResendCode('Datos reenviados con exito')
    );
  } catch (e) {
    if (e.response.status === 401) {
      throw e;
    }
    yield put(
      appointmentActions.error('Ocurrió un problema al operar la solicitud')
    );
  }
  yield put(appointmentActions.loading(false));
}

export function refreshToken(saga) {
  return function* (action) {
    // yield put(appointmentActions.loading(true));
    const actionToken = { payload: { ...action.payload, token: true } };
    try {
      yield* saga(actionToken);
    } catch (error) {
      if (
        error.response.status === 401 &&
        error.response.data.code === 'token_not_valid'
      ) {
        const reduxStore = store;
        try {
          //Try refresh token
          const token = yield call(API.refreshToken, {
            refresh: reduxStore.getState().session.refreshToken,
          });
          yield put(
            userActions.successTokenRefresh({
              // message: 'Nuevo token obtenido con éxito',
              token: token.data,
            })
          );
          yield* saga(actionToken);
        } catch (error) {
          if (
            error.response.status === 401 &&
            error.response.data.code === 'token_not_valid'
          ) {
            yield put(userActions.logoutUser()); //Refresh token expired
          }
        }
      }
    }
    // yield put(appointmentActions.loading(false));
  };
}
function* getAppointmentsAll(action) {
  yield put(appointmentActions.loading(true));
  try {
    const {
      userType,
      id,
      token,
      isDone,
      isPayed,
      queryParams,
      queryValues,
      isCanceled = false,
      appointmentId,
    } = action.payload;
    // if we dont have an appointment id, then we process the queryparams for retrieving a list of appointments.
    let urlParams = `${userType}__id=${id}&is_done=${isDone}&is_cancelled=${isCanceled}`;
    if (!appointmentId) {
      if (queryParams.length > 0) {
        for (let i = 0; i < queryParams.length; i++) {
          urlParams += `&${queryParams[i]}=${queryValues[i]}`;
        }
      }
    }

    const response = yield call(
      API.getAppointmentsAll,
      urlParams,
      token,
      appointmentId
    );

    yield put(appointmentActions.successGetAppointment(response.data));
  } catch (e) {
    console.log('ERROR', e);
    if (e.response.status === 401) {
      throw e;
    }
    yield put(appointmentActions.error('Error al traer los datos'));
  }
  yield put(appointmentActions.loading(false));
}

export default function* appointmentSaga() {
  yield takeEvery(
    appointmentActionsTypes.GET_APPOINTMENTS,
    refreshToken(getAppointments)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_SCHEDULE_REQUESTS,
    refreshToken(getScheduleRequests)
  );
  yield takeEvery(
    appointmentActionsTypes.CREATE_SCHEDULE_REQUESTS,
    refreshToken(createScheduleRequests)
  );
  yield takeEvery(
    appointmentActionsTypes.UPDATE_SCHEDULE_REQUESTS,
    refreshToken(updateScheduleRequests)
  );
  yield takeEvery(
    appointmentActionsTypes.ACCEPT_SCHEDULE_REQUESTS,
    refreshToken(acceptScheduleRequests)
  );
  yield takeEvery(
    appointmentActionsTypes.CREATE_SCHEDULE,
    refreshToken(createSchedule)
  );

  yield takeEvery(
    appointmentActionsTypes.DELETE_SCHEDULE,
    refreshToken(deleteSchedule)
  );

  yield takeEvery(
    appointmentActionsTypes.GET_SCHEDULES_BY_DATE,
    refreshToken(getSchedules)
  );

  yield takeEvery(
    appointmentActionsTypes.CREATE_APPOINTMENT,
    refreshToken(createAppointment)
  );

  yield takeEvery(
    appointmentActionsTypes.UPDATE_APPOINTMENT,
    refreshToken(updateAppointment)
  );
  yield takeEvery(
    appointmentActionsTypes.UPLOAD_APPOINTMENT_FILES,
    refreshToken(uploadAppointmentFiles)
  );
  yield takeEvery(
    appointmentActionsTypes.DELETE_APPOINTMENT,
    refreshToken(deleteAppointment)
  );
  yield takeEvery(
    appointmentActionsTypes.DELETE_APPOINTMENT_FILE,
    refreshToken(deleteAppointmentFile)
  );
  yield takeEvery(
    appointmentActionsTypes.UPLOAD_APPOINTMENT_CONSENT_FILE,
    refreshToken(uploadConsentFile)
  );
  yield takeEvery(
    appointmentActionsTypes.DELETE_APPOINTMENT_CONSENT_FILE,
    refreshToken(deleteAppointmentConsentFile)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_APPOINTMENTS_LIGHT,
    refreshToken(getAppointmentsLight)
  );
  yield takeEvery(
    appointmentActionsTypes.CREATE_APPOINTMENT_LIGHT,
    refreshToken(createAppointmentLight)
  );
  yield takeEvery(
    appointmentActionsTypes.UPDATE_APPOINTMENT_LIGHT,
    refreshToken(updateAppointmentLight)
  );
  yield takeEvery(
    appointmentActionsTypes.RESEND_CODE,
    refreshToken(resendCode)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_APPOINTMENTS_ALL,
    refreshToken(getAppointmentsAll)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_APPOINTMENT_PDF_DETAILS,
    refreshToken(getAppointmentPDFdetails)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_APPOINTMENT_CONSENT_FILE,
    refreshToken(getAppointmentConsentFile)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_CONSULTATION_FORMAT,
    refreshToken(getConsultationFormat)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_ICD_CODE_BY_APPOINTMENT_ID,
    refreshToken(getIcdCodeByAppointmentId)
  );
  yield takeEvery(
    appointmentActionsTypes.GET_RAPID_QUEUES,
    refreshToken(getRapidQueues)
  );
  yield takeEvery(
    appointmentActionsTypes.RAPID_QUEUE_PUSH,
    refreshToken(rapidQueuePush)
  );
  yield takeEvery(
    appointmentActionsTypes.RAPID_QUEUE_TAKE_PATIENT,
    refreshToken(rapidQueueTakePatient)
  );
}
